import React, { FC } from 'react';
import classNames from 'classnames';

import { PlanTypes } from 'types';

import hexToRGB from 'utils/hexToRgb';

interface Props extends PlanTypes {
    isActive: boolean;
    onClick: () => void;
}

const PlanCard: FC<Props> = ({ isActive, onClick, tooltip, period, oldPrice, price, perDay }) => {
    const themColor = document.documentElement.style.getPropertyValue('--them-color');

    return (
        <button
            style={{ borderColor: isActive && !tooltip ? `${hexToRGB(themColor, '.7')}` : '' }}
            type="button"
            className={classNames('plan-card', {
                'plan-card--popular': !!tooltip,
                'plan-card--active': isActive,
            })}
            onClick={onClick}
        >
            {tooltip && <p className="plan-card__tooltip">{tooltip}</p>}
            <p className="plan-card__wraper">
                <span className="plan-card__check">
                    <span style={{ backgroundColor: isActive && !tooltip ? `${hexToRGB(themColor, '1')}` : '' }} />
                </span>
                <p>
                    <p className="plan-card__period">{period}</p>
                    <p className="plan-card__old-price" dangerouslySetInnerHTML={{ __html: oldPrice }} />
                    <p className="plan-card__price" dangerouslySetInnerHTML={{ __html: price }} />
                </p>
            </p>
            <div className="plan-card__day" dangerouslySetInnerHTML={{ __html: perDay }} />
        </button>
    );
};

export default PlanCard;
